import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import login from '../views/login'

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error=> error)
};

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/login',
        name: 'Login',
        component: login
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        children: [
            /** 知识库 */
            { // 图文
                path: '/courseView',
                name: 'courseView',
                component: () => import('../components/learning/index.vue')
            },
            { // 上传视频
                path: '/uploadVideo',
                name: 'uploadVideo',
                component: () => import('../components/uploadVideo/index.vue')
            },

            { // 周期活动管理
                path: '/activityView',
                name: 'activityView',
                component: () => import('../components/activity/index.vue')
            },
            { // 推送规则
                path: '/pushRoleView',
                name: 'pushRoleView',
                component: () => import('../components/pushRole/index.vue')
            },
            { // 问候语
                path: '/greetingsView',
                name: 'greetingsView',
                component: () => import('../components/greetings/index.vue')
            },
            { // 通用提醒
                path: '/comRemindView',
                name: 'comRemindView',
                component: () => import('../components/comRemind/index.vue')
            },
            /** 业务运营 */
            { // 患者管理
                path: '/illUserView',
                name: 'illUserView',
                component: () => import('../components/illUser/index.vue')
            },
            { // 员工
                path: '/staffView',
                name: 'staffView',
                component: () => import('../components/staff/index.vue')
            },
            { // 病种管理
                path: '/illView',
                name: 'illView',
                component: () => import('../components/ill/index.vue')
            },
            { // 医院管理
                path: '/hospitalView',
                name: 'hospitalView',
                component: () => import('../components/hospital/index.vue')
            },
            { // 医生管理
                path: '/doctorView',
                name: 'doctorView',
                component: () => import('../components/doctor/index.vue')
            },
            { // 药师管理
                path: '/pharmacist',
                name: 'pharmacist',
                component: () => import('../components/pharmacist/index.vue')
            },
            { // 活动管理
                path: '/activeManageView',
                name: 'activeManageView',
                component: () => import('../components/activeManage/index.vue')
            },
            { // 历史数据
                path: '/hisDataEditView',
                name: 'hisDataEditView',
                component: () => import('../components/his_data_edit/tableView.vue')
            },
            { // 数据修复
                path: '/dataRecovery',
                name: 'dataRecovery',
                component: () => import('../components/dataRecovery/index.vue')
            },
            /** 系统管理 */
            { // 系统用户
                path: '/systemUserView',
                name: 'systemUserView',
                component: () => import('../components/systemUser/index.vue')
            },
            { // 患者数据
                path: '/patientData',
                name: 'patientData',
                component: () => import('../components/patientData/index.vue')
            },
            { // 注册审核
                path: '/illAuditView',
                name: 'illAuditView',
                component: () => import('../components/illAudit/index.vue')
            },
            { // 发票审核
                path: '/billAuditView',
                name: 'billAuditView',
                component: () => import('../components/billAudit/index.vue')
            },
            { // 填报进度
                path: '/PAScheduleView',
                name: 'PAScheduleView',
                component: () => import('../components/PASchedule/index.vue')
            },
            { // 问卷管理
                path: '/questionnaireView',
                name: 'questionnaireView',
                component: () => import('../components/questionnaire/index.vue')
            },
            { // 操作日志
                path: '/ULogView',
                name: 'ULogView',
                component: () => import('../components/ULogView.vue')
            },
            { // 字典管理
                path: '/dictionariesView',
                name: 'dictionariesView',
                component: () => import('../components/dictionaries/index.vue')
            },
            { // 直播管理
                path: '/liveView',
                name: 'liveView',
                component: () => import('../components/liveSetting/index.vue')
            },
            { // 积分配置
                path: '/integralView',
                name: 'integralView',
                component: () => import('../components/integral/index.vue')
            },
            { // 随访工单
                path: '/followVisitView',
                name: 'followVisitView',
                component: () => import('../components/follow_visit/index.vue')
            },
            { // 随访指定清单
                path: '/followUpList',
                name: 'followUpList',
                component: () => import('../components/follow_upList/index.vue')
            },
            { // 药店列表
                path: '/drugstoreView',
                name: 'drugstoreView',
                component: () => import('../components/drugstoreView.vue')
            },
            { // 产品配置
                path: '/drugConfigView',
                name: 'drugConfigView',
                component: () => import('../components/drugConfig/index.vue')
            },
            { // 个人首页
                path: '/personalHomepage',
                name: 'personalHomepage',
                component: () => import('../components/personalHomepage/index.vue')
            },
            { // 留言咨询
                path: '/advisoryMessages',
                name: 'advisoryMessages',
                component: () => import('../components/advisoryMessages/index.vue')
            },
            { // hash工具
                path: '/hashView',
                name: 'hashView',
                component: () => import('../components/hashView.vue')
            },
            // 系统设置

            // 消息列表
            {
                path: '/readMsgView',
                name: 'readMsgView',
                component: () => import('../components/read_msg/index.vue')
            },
        ]
    },

];

const router = new VueRouter({
    routes
});

export default router
